import React from "react";
import { useTranslation } from "react-i18next";
import {
  Identifiable,
  Project,
  project,
  ProjectPortfolio,
} from "@planzone/dto";
import { useRetrieveProjectPortfolios } from "@planzone/view-models";

import { ModelSelection } from "./modelSelection";
import { ProjectEdition } from "./projectEdition";
import { Props } from "./types";

function extractAssignedPortfolios(
  project: Identifiable<Project>,
  portfolios: Identifiable<ProjectPortfolio>[],
): Identifiable<ProjectPortfolio>[] {
  return portfolios.reduce<Identifiable<ProjectPortfolio>[]>(
    (sum, portfolio) =>
      !!portfolio.projects.find(({ uuid }) => uuid === project.uuid)
        ? [...sum, portfolio]
        : sum,
    [],
  );
}

function ProjectCreationFromModel({ zone, model, close }: Props) {
  const { t } = useTranslation();
  const [selectedZone, setSelectedZone] = React.useState(zone || null);
  const [selectedProjectModel, setSelectedProjectModel] = React.useState(
    model || project,
  );
  const [initialPortfolios, setInitialPortfolios] = React.useState<
    Identifiable<ProjectPortfolio>[]
  >([]);
  const { portfolios } = useRetrieveProjectPortfolios();

  React.useEffect(() => {
    if (!!selectedProjectModel.uuid) {
      setInitialPortfolios(
        extractAssignedPortfolios(selectedProjectModel, portfolios),
      );
    }
  }, [selectedProjectModel.uuid]);

  return !!selectedProjectModel.uuid ? (
    <ProjectEdition
      zone={selectedZone}
      projectModel={selectedProjectModel}
      initialPortfolios={initialPortfolios}
      isMultiProject={!zone}
      close={close}
      selectZone={setSelectedZone}
    />
  ) : (
    <ModelSelection selectModel={setSelectedProjectModel} close={close} />
  );
}

export { ProjectCreationFromModel };
